import React from "react";

import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { OpenIcon, WarningTriangleIcon } from "globals/design-system/icons";
import { errorRed, moovsBlue } from "globals/design-system/colors";

type DivertedFlightInfoProps = {
  flightNumber: string;
};

function DivertedFlightInfo(props: DivertedFlightInfoProps) {
  const { flightNumber } = props;

  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  // event handlers
  const handleViewFlightAwareLink = () => {
    window.open(
      `https://flightaware.com/live/flight/${flightNumber}`,
      "_blank"
    );
  };

  return (
    <Box display="flex" flexDirection={isMobileView ? "column" : "row"}>
      <Box
        display="flex"
        flex={1}
        justifyContent={isMobileView ? "center" : "flex-end"}
        alignItems="center"
        {...(isMobileView ? { mb: 2 } : { mr: 2 })}
      >
        <Box mt="4px" mr={1}>
          <WarningTriangleIcon size="small" color={errorRed} />
        </Box>
        <Typography
          variant="body2"
          style={{ fontWeight: 500, color: errorRed }}
        >
          Flight has been diverted
        </Typography>
      </Box>
      <Box flex={1}>
        <Button
          color="primary"
          fullWidth
          variant="outlined"
          endIcon={<OpenIcon size="small" color={moovsBlue} />}
          onClick={handleViewFlightAwareLink}
        >
          View on FlightAware
        </Button>
      </Box>
    </Box>
  );
}

export default DivertedFlightInfo;
